import { IFileSize } from '@/types/fileSize.types';

export enum DataSizeUnit {
  Bytes = 'Bytes',
  KB = 'Kb',
  MB = 'Mb',
  GB = 'GB',
}

const bytesInKb = 1024;
const DataSizeUnits = {
  [DataSizeUnit.Bytes]: 1,
  [DataSizeUnit.KB]: bytesInKb,
  [DataSizeUnit.MB]: bytesInKb ** 2,
  [DataSizeUnit.GB]: bytesInKb ** 3,
};

export const convertSizeToBytes = (fileSize: IFileSize): number => {
  if (!(fileSize.unit in DataSizeUnits)) {
    throw new Error(
      `Invalid unit: ${fileSize.unit}. Please use one of the following: ${Object.values(DataSizeUnit).join(', ')}`,
    );
  }

  return fileSize.size * DataSizeUnits[fileSize.unit];
};

export const convertBytesToHumanReadableFormat = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const base = 1000;
  const units = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(base));

  return `${(bytes / base ** i).toFixed(0)} ${units[i]}`;
};
